const TOTAL_ONLINE_KEY = "totalOnline";
const TOTAL_OFFLINE_KEY = "totalOffline";
const TOTAL_HIBERNATING_KEY = "totalHibernating";
const TOTAL_NEEDS_SOFTWARE_UPGRADE_KEY = "totalNeedsSoftwareUpgrade";
const TOTAL_NEEDS_FIRMWARE_UPGRADE_KEY = "totalNeedsFirmwareUpgrade";

const DEVICE_HIBERNATING = {
  chartColor: "#A1DB2A",
  code: 1,
  color: "teal",
  iconClass: "fa-moon-o",
  id: "hibernating",
  label: "Hibernating",
  textClass: "text-muted",
};

const DEVICE_OFFLINE = {
  chartColor: "#DD4B39",
  code: 2,
  color: "red",
  iconClass: "fa-arrow-down",
  id: "offline",
  label: "Offline",
  textClass: "text-danger",
};

const DEVICE_ONLINE = {
  chartColor: "#00A65A",
  code: 0,
  color: "green",
  iconClass: "fa-arrow-up",
  id: "online",
  label: "Online",
  textClass: "text-success",
};

const DEVICE_SHELL = {
  chartColor: "#777",
  code: 0,
  color: "grey",
  iconClass: "fa-circle-o",
  id: "shell",
  label: "Registered, Never Connected",
  textClass: "text-muted",
};

const DEVICE_NEEDS_UPGRADE = {
  color: "yellow",
  iconClass: "fa-level-up",
  id: "needsUpgrade",
  label: "Needs Upgrade",
  textClass: "text-warning",
};

const DEVICE_DOWNGRADES = {
  color: "red",
  iconClass: "fa-level-down",
  id: "needsDowngrade",
  label: "Needs Downgrade",
  textClass: "text-warning",
};

const DEVICE_ALL = {
  code: -1,
  label: "All",
  id: "total",
};

const DEVICE_STATUS_CLASSES = {
  unknown: { label: "Unknown", className: "fa fa-circle text-warning" },
  online: { label: "Online", className: "fa fa-circle text-success" },
  offline: { label: "Offline", className: "fa fa-circle text-danger" },
};

const DEVICE_STATUS_CODES = {
  [DEVICE_ONLINE.code]: DEVICE_ONLINE.label,
  [DEVICE_HIBERNATING.code]: DEVICE_HIBERNATING.label,
  [DEVICE_OFFLINE.code]: DEVICE_OFFLINE.label,
};

const DEVICE_STATUS_SELECT_OPTIONS = [
  { value: DEVICE_ONLINE.code, label: DEVICE_ONLINE.label },
  { value: DEVICE_HIBERNATING.code, label: DEVICE_HIBERNATING.label },
  { value: DEVICE_OFFLINE.code, label: DEVICE_OFFLINE.label },
];

// As we introduce device status pipeline to synchronize state, this
// limit should be 2x the ws polling period to have margins for latency.
const DEVICE_STATUS_TIMEOUT_MS = 120000;

export {
  DEVICE_ALL,
  DEVICE_HIBERNATING,
  DEVICE_NEEDS_UPGRADE,
  DEVICE_DOWNGRADES,
  DEVICE_OFFLINE,
  DEVICE_ONLINE,
  DEVICE_SHELL,
  DEVICE_STATUS_CLASSES,
  DEVICE_STATUS_CODES,
  DEVICE_STATUS_SELECT_OPTIONS,
  DEVICE_STATUS_TIMEOUT_MS,
  TOTAL_NEEDS_FIRMWARE_UPGRADE_KEY,
  TOTAL_NEEDS_SOFTWARE_UPGRADE_KEY,
  TOTAL_HIBERNATING_KEY,
  TOTAL_OFFLINE_KEY,
  TOTAL_ONLINE_KEY,
};
